import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const FilePreviewModal = ({ file, renderFileIcon }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const renderPreview = () => {
    if (!file || !file.playback_url) {
      return <p className="text-center">No preview available.</p>;
    }

    switch (file.file_type) {
      case 'video':
        return (
          <video width="100%" controls autoPlay>
            <source src={file.playback_url} type={file.content_type || 'video/mp4' || 'video/webm'} />
            Your browser does not support the video tag.
          </video>
        );
      case 'image':
        return <img src={file.playback_url} alt={file.video_title} style={{ maxWidth: '100%', maxHeight: '70vh', display: 'block', margin: 'auto' }} />;
      case 'audio':
        return (
          <audio controls autoPlay style={{ width: '100%' }}>
            <source src={file.playback_url} type={file.content_type || 'audio/mpeg'} />
            Your browser does not support the audio element.
          </audio>
        );
      case 'document': 
        return <iframe src={file.playback_url} title={file.video_title} style={{ width: '100%', height: '75vh', border: 'none' }} />;
      default:
        return <p className="text-center">No preview available for this file type.</p>;
    }
  };

  return (
    
    <>
      <Button variant="link" onClick={handleShow} title="Preview File">
        {renderFileIcon ? renderFileIcon(file) : <i className="ri-file-line fs-20 me-2"></i>}
      </Button>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{file.video_title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderPreview()}</Modal.Body>
      </Modal>
    </>
  );
};

export default FilePreviewModal;
